import router from "../router";
import jwt from "jwt-decode";
// import jwt from "jsonwebtoken";
// import jwksClient from "jwks-rsa";

export default {
    state: {
        profile: null,
        accessToken: null,
        refreshToken: null,
        verification: null,
        isAuthenticated: false,
        count: 0,
        accountId: null
    },

    getters: {
        profile: state => state.profile,
        verification: state => state.verification,
        accessToken: state => state.accessToken,
        refreshToken: state => state.refreshToken,
        idToken: state => state.idToken,
        isAuthenticated: state => state.isAuthenticated,
        accountId: state => state.accountId
    },

    mutations: {
        setProfile: (state, profile) => {
            state.profile = profile;
        },
        setAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        },
        setRefreshToken: (state, refreshToken) => {
            state.refreshToken = refreshToken;
        },
        setIdToken: (state, idToken) => {
            state.idToken = idToken;
        },
        setVerification: (state, verification) => {
            state.verification = verification;
        },
        setAuthenticated: (state, isAuthenticated) => {
            state.isAuthenticated = isAuthenticated;
        },
        setAccountId: (state, accountId) => {
            state.accountId = accountId;
        }
    },

    actions: {
        signout: function (context/*, payload*/) {
            context.commit("setProfile", null);
            context.commit("setAccessToken", null);
            context.commit("setRefreshToken", null);
            context.commit("setAuthenticated", false);
            context.commit("setAccountId", null);
            router.push({ name: "home" });
        },
        changeAccount: function(context, accountId) {
        	context.commit("setAccountId", accountId);
        },
        
        authenticate: function(context, payload) {
            // console.debug("store", "authenticate");
            if (payload.verification === null || payload.verification !== context.getters.verification) {
                router.push({
                    name: "error",
                    params: {
                        message:
                            "The verification state in the authentication response did not match our original request"
                    }
                });
                return;
            }
/*
            if (payload.idToken === null || (jwt(payload.idToken).token_use || null) !== "id") {
                router.push({
                    name: "error",
                    params: {
                        message:
                            "The authentication response did not include a valid ID token"
                    }
                });
                return;
            }
*/
            context.commit("setProfile", payload.idToken?jwt(payload.idToken):null);
            context.commit("setAccessToken", payload.accessToken);
            context.commit("setRefreshToken", payload.refreshToken);
            context.commit("setIdToken", payload.idToken);
            context.commit("setAuthenticated", true);
            context.commit("setAccountId", null);
            // jwt.verify(payload.idToken, getKey())

            router.push({ name: "account" });
        } /*,
        verify(tk) {
            const decoded = jwt.verify(tk, getKey);
            console.debug("decoded", decoded);
        },

        getKey(tk) {
            const decoded = jwt.decode(tk);
            const header = Buffer.from(tk.split(".")[0], "base64").toString();
            const client = jwksClient({
                jwksUri: decoded.iss + ".well-known/jwks.json"
            });
            client.getSigningKey(header.kid);
        }
        */
    }
};
